import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="table-filters"
export default class extends Controller {
  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 200)
  }

  filter() {
    this.element.requestSubmit();
  }

  sort() {
    document.getElementById('sort-column').value = this.element.dataset['sort'];
    document.getElementById('sort-method').value = this.element.dataset['asc'];

    document.getElementById('filters').requestSubmit();
  }

  clear() {
    this.element.querySelectorAll('input, select').forEach((el) => { el.value = ''; });
    this.element.requestSubmit();
  }
}